/* eslint-disable max-len */
import { PlusOutlined, SaveOutlined } from '@ant-design/icons';
import {
  Breadcrumb, Button, Form, Input, Select, Card, Row, Col,
} from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
// import { PlusOutlined } from '@ant-design/icons';

import withAuth from '@common/hocs/withAuth';
import MainLayout from '@common/layouts/MainLayout';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch } from '@fortawesome/free-solid-svg-icons';

import styles from './CreateGateway.module.less';
import useCreateGateway from './useCreateGateway';

function CreateGateway() {

  const { t } = useTranslation();
  const {
    onFinish,
    onFinishFailed,
    formOnValuesChange,
    dataForm, 
    dataFirmwares, 
    idToEdit,
    cancelCreateEditGateway,
    handleGatewayHome,
    loadingSave,
    businessData,
    onDataFw
  } = useCreateGateway();

  const ExpRegSoloNumeros="^[0-9]+$";

  return (
    <MainLayout applyWidthLimit>
      <div className={styles.wrapper}>
        <Form
          name="CreateDevice"
          layout="vertical"
          initialValues={{
            ...dataForm, remenber: true,
          }}
          values={{ name: 'jhon', client: 'example', state: 'normal' }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          onValuesChange={formOnValuesChange}
          autoComplete="off"
        >
          <Card style={{ width: '100%', marginBottom: '1rem' }}>
            <Row>
              <Col  xs={{span: 24 }}  sm={{span: 24 }}  md={{span: 20 }}  lg={{span: 20 }}  xl={{span: 20 }} >
                <div className={styles.section_title}>{idToEdit?t('views.create_gateway.edit_gateway'):t('views.create_gateway.new_gateway')}</div>
                <Breadcrumb className={styles.date_wrapper}>
                  <>
                    <Breadcrumb.Item className={styles.breadcrumb}>
                      <Link to="/tablero-general">Home</Link>
                    </Breadcrumb.Item>

                    <Breadcrumb.Item className={styles.breadcrumb}>
                      <a onClick={handleGatewayHome}>
                        Gateway
                      </a>
                    </Breadcrumb.Item>
                  </>

                  {(idToEdit)
                    ? (
                      <>
                        <Breadcrumb.Item className={styles.breadcrumb}>{t('menu_items.main.devices_edit')}</Breadcrumb.Item>
                        <Breadcrumb.Item className={styles.breadcrumb}>{dataForm && dataForm.name}</Breadcrumb.Item>
                      </>
                    )
                    : <Breadcrumb.Item className={styles.breadcrumb}>{t('views.create_gateway.new_gateway')}</Breadcrumb.Item>}
                </Breadcrumb>
              </Col> 

              <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}
                className={styles.column_btn}
              > 
                <Button onClick={cancelCreateEditGateway}>X</Button>

                <Button key="button"  className='m_l' type="primary" loading={loadingSave} htmlType="submit" icon={(!idToEdit) ?<PlusOutlined />:null} >
                 {(!idToEdit) ? t('views.create_business_type.buttons.create') : t('views.create_business_type.buttons.update') }
                </Button> 

              </Col>


            </Row>
          </Card>

          <Card style={{ width: '100%' }}>
            <div className={styles.containerForm}>
              <Row gutter={[16, 8]}>

                <Col xs={{span: 24,order: 1, }} sm={{span: 24,order: 1, }} md={{span: 24,order: 1, }} lg={{span: 12,order: 1, }} xl={{span: 12,order: 1, }}
                  >
                    <Form.Item
                      className={styles.label}
                      label={t('views.create_gateway.form.name')}
                      name="name"
                      rules={[
                        { required: true, message: t('views.create_gateway.form.name_message') },
                        { type: 'string', max: 16, message: t('views.create_gateway.form.name_message_max') },
                      ]}
                    >
                      <Input className={styles.input} placeholder={t('views.create_gateway.form.name_place_holder')} />
                    </Form.Item>
                </Col> 

                
                <Col xs={{span: 24,order: 1, }} sm={{span: 24,order: 1, }} md={{span: 24,order: 1, }} lg={{span: 12,order: 1, }} xl={{span: 12,order: 1, }}>
                  <Form.Item
                    className={styles.label}
                    label={t('forms.users.labels.business_line')}
                    name="busines_id"//business_type
                    rules={[
                      {
                        required: true,
                        message: t('forms.users.placeholders.business_line'),
                      },
                    ]}
                  >
                    <Select
                      onChange={(value) => onDataFw(value)} 
                      style={{ width: '100%' }}
                      disabled={idToEdit}
                      placeholder={t('forms.users.placeholders.business_line')} 
                      options={businessData}

                    /> 
                  </Form.Item>
                </Col>
                 

                <Col xs={{span: 24,order: 1, }} sm={{span: 24,order: 1, }} md={{span: 24,order: 1, }} lg={{span: 12,order: 1, }} xl={{span: 12,order: 1, }}
                  >
                    <Form.Item
                      className={styles.label}
                      label={t('views.create_gateway.form.mac')}
                      name="mac"
                      rules={[
                        { required: true, message: t('views.create_gateway.form.mac_message') },
                        { type: 'string', max: 16, message: t('views.create_gateway.form.mac_message_max') },
                      ]}
                    >
                      <Input className={styles.input} placeholder={t('views.create_gateway.form.mac_place_holder')} />
                    </Form.Item>
                </Col>
                
                <Col xs={{span: 24,order: 4, }} sm={{span: 24,order: 4, }} md={{span: 24,order: 4, }} lg={{span: 12,order: 2, }} xl={{span: 12,order: 2, }}
                >
                  <Form.Item
                    className={styles.label}
                    label={t('views.create_gateway.form.fw_assigned_id')}
                    name="fw_assigned_id"
                    rules={[{ required: true, message: t('views.create_gateway.form.fw_assigned_id_message') }]}
                  >
                    <Select
                      className={styles.select}
                    >
                      {dataFirmwares.map((firmware) => (
                        <Select.Option key={firmware.id} value={firmware.id}>{firmware.fw_url}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col> 
              
                <Col xs={{span: 24,order: 3, }} sm={{span: 24,order: 3, }} md={{span: 24,order: 3, }} lg={{span: 12,order: 5, }} xl={{span: 12,order: 5, }}
                >
                  <Form.Item
                    className={styles.label}
                    label={t('views.create_gateway.form.communication_interface')}
                    name="hwInt"
                    rules={[{ required: true, message: t('views.create_gateway.form.communication_interface_message') }]}
                  > 
                    <Select className={styles.select}>
                      <Select.Option value="RS485">RS485</Select.Option>
                      <Select.Option value="RS232">RS232</Select.Option>
                      <Select.Option value="CAN">CAN</Select.Option> 
                    </Select>

                  </Form.Item>
                </Col>
                
                <Col  xs={{span: 24,order: 3,  }}  sm={{span: 24,order: 3,  }}  md={{span: 24,order: 3,  }}  lg={{span: 12,order: 5,  }}  xl={{span: 12,    order: 5,  }}
                >
                  <Form.Item
                    className={styles.label}
                    label={t('views.create_gateway.form.baud_rate')}
                    name="baud"
                    rules={[{ required: true, message: t('views.create_gateway.form.baud_rate_message') }]}
                  > 
                    <Select className={styles.select}>
                      <Select.Option value="4800">4800</Select.Option>
                      <Select.Option value="9600">9600</Select.Option>
                      <Select.Option value="11400">11400</Select.Option>
                      <Select.Option value="19200">19200</Select.Option>
                      <Select.Option value="57600">57600</Select.Option>
                      <Select.Option value="115200">115200</Select.Option>
                    </Select>

                  </Form.Item>
                </Col>
                
                <Col xs={{span: 24,order: 3, }} sm={{span: 24,order: 3, }} md={{span: 24,order: 3, }} lg={{span: 12,order: 5, }} xl={{span: 12,order: 5, }}
                >
                  <Form.Item
                    className={styles.label}
                    label={t('views.create_gateway.form.sampling_interval')}
                    name="ival"
                    rules={[{ required: true, message: t('views.create_gateway.form.sampling_interval_message') },
                            {
                              validator: (_, value) =>
                                value && value.match(ExpRegSoloNumeros)!=null
                                  ? Promise.resolve()
                                  : Promise.reject(new Error(t('views.dynamic_device_types_create_edit.feedbacks.required_input_number'))),
                            }
                          ]}
                  >
                    <Input className={styles.input} placeholder={t('views.create_gateway.form.sampling_interval_place_holder')} />
                  </Form.Item>
                </Col>

                <Col xs={{span: 24,order: 3, }} sm={{span: 24,order: 3, }} md={{span: 24,order: 3, }} lg={{span: 12,order: 5, }} xl={{span: 12,order: 5, }}
                >
                  <Form.Item
                    className={styles.label}
                    label={t('views.create_gateway.form.latitude')}
                    name="latitude"
                    rules={[{ required: true, message: t('views.create_gateway.form.latitude_message') }]}
                  >
                    <Input className={styles.input} placeholder={t('views.create_gateway.form.latitude_place_holder')} />
                  </Form.Item>
                </Col>
                
                <Col xs={{ span: 24, order: 3, }} sm={{ span: 24, order: 3, }} md={{ span: 24, order: 3, }} lg={{ span: 12, order: 5, }} xl={{ span: 12, order: 5, }}
                >
                  <Form.Item
                    className={styles.label}
                    label={t('views.create_gateway.form.longitude')}
                    name="longitude"
                    rules={[{ required: true, message: t('views.create_gateway.form.longitude_message') }]}
                  >
                    <Input className={styles.input} placeholder={t('views.create_gateway.form.longitude_place_holder')} />
                  </Form.Item>
                </Col>

              </Row>
            </div>
          </Card>
        </Form>
      </div>
    </MainLayout>
  );

}

export default withAuth(CreateGateway);
